@if (type !== 'indeterminate') {
  <mat-spinner [strokeWidth]="strokeWidth" ngClass="{{ size }} {{ color }}" />
}

@if (type === 'indeterminate') {
  <mat-progress-bar mode="indeterminate" />
}
